/* eslint-disable no-unused-expressions */

import React, { Component } from "react";
import { withTranslation } from "react-i18next";
import sysJwt from "../../../utils/sysJwt";
import SysForm from "../../commonComponents/sysForm";
import { post } from "../../../utils/sysAxios";
import { Dialog } from "primereact/dialog";
import { Button } from "primereact/button";
import { confirmAlert } from "react-confirm-alert";
import SysTable from "../../commonComponents/SysTable";
import { Dropdown } from "primereact/dropdown";
import { ExportSheet } from "react-xlsx-sheet";
import XLSX from "xlsx";

class InternetSubscribeTypes extends Component {
  state = {
    data: {
      Name: "",
      Series: "",
      Price: "",
      InternetType: "",
      CompoundId: "",
    },

    contentHeader: "Internet Subscribe Types",
    addButtonLabel: "Add Type",
    addButtonIcon: "fa fa-plus",

    dataUrl: "/api/data/GetInternetSubscribeTypes",
    singleItemUrl: "/api/data/GetInternetSubscribeType",
    addUrl: "/api/data/AddInternetSubscribeType",
    editUrl: "/api/data/EditInternetSubscribeType",
    deleteUrl: "/api/data/DeleteInternetSubscribeType",

    inEditMode: false,
    inModalMode: false,
    modalHeaderAdd: "Add Internet Subscribe Type",
    modalSubmitButtonLabelAdd: "Add",
    modalSubmitButtonIconAdd: "fa fa-plus",
    modalHeaderEdit: "Edit Internet Subscribe Type",
    modalSubmitButtonLabelEdit: "Edit",
    modalSubmitButtonIconEdit: "fa fa-edit",
    modalWidth: "50vw",

    editEntityId: 0,

    internetTypesDropdown: [],
    compoundsDropdown: [],

    filterCompoundId: "",
    xlsxHeaders: [],

    tableData: [],
  };

  getColumns() {
    const { t } = this.props;
    return [
      {
        id: 1,
        label: t("col.name"),
        field: "NAME",
      },
      {
        id: 2,
        label: t("col.series"),
        field: "SERIES",
      },
      {
        id: 3,
        label: t("col.price"),
        field: "PRICE",
      },
      {
        id: 5,
        label: t("col.provider"),
        field: "INTERNET_TYPE",
      },
      {
        id: 6,
        label: t("col.compound"),
        field: "COUMPOUND",
      },
      {
        id: 7,
        label: t("col.lastUpdate"),
        field: "LAST_UPDATE",
      },
      {
        id: 8,
        label: t("col.actions"),
        field: "SYS_ACTINOS",
        width: "100px",
        maxResizeWidth: "100px",
        resizable: false,
        pinned: true,
        cellRenderer: ({ data }) => {
          return (
            <div id="outer">
              {sysJwt.isAuthorized(["CB6B"]) && (
                <div className="inner" title="Edit">
                  <button
                    className="dropdown-item btn-popup-menu"
                    disabled={this.props.isLoading}
                    onClick={() => {
                      this.getEditFormData(data).then(() => {
                        this.setState({
                          inEditMode: true,
                        });
                        this.showForm();
                      });
                    }}
                  >
                    <i className="fa fa-edit" />
                  </button>
                </div>
              )}
              {sysJwt.isAuthorized(["CB6C"]) && (
                <div className="inner" title="Delete">
                  <button
                    className="dropdown-item btn-popup-menu"
                    disabled={this.props.isLoading}
                    onClick={() => this.handleDelete(data)}
                  >
                    <i className="fa fa-trash" />
                  </button>
                </div>
              )}
            </div>
          );
        },
      },
    ];
  }

  componentDidMount() {
    this.getData();
    this.getAllInternetTypes();
    this.getCompoundsDropdown();
  }

  getAllInternetTypes() {
    post(
      "/api/data/GetAllInternetProviders",
      null,
      this.props.updateIsLoading
    ).then((apiResponse) => {
      this.setState({
        internetTypesDropdown: apiResponse.data.respData.data,
      });
    });
  }

  getCompoundsDropdown() {
    post(
      "/api/data/GetAllCompoundsDropdown",
      null,
      this.props.updateIsLoading
    ).then((apiResponse) => {
      this.setState({
        compoundsDropdown: apiResponse.data.respData.data,
      });
    });
  }

  updateForm = (inputId, inputValue) => {
    var data = this.state.data;
    data[inputId] = inputValue;
    this.setState({ data });
  };

  showForm() {
    this.setState({ inModalMode: true });
  }

  closeModal() {
    var data = this.state.data;

    Object.keys(data).forEach(function (key) {
      Array.isArray(data[key]) ? (data[key] = []) : (data[key] = "");
    });

    this.setState({
      inModalMode: false,
      inEditMode: false,
      data: data,
      editEntityId: 0,
    });

    this.getData();
  }

  getData() {
    post(this.state.dataUrl, null, this.props.updateIsLoading).then(
      (apiResponse) => {
        const rows = apiResponse.data.respData.data;
        this.setState({ tableData: rows });
        this.buildExportHeaders(rows);
      }
    );
  }

  buildExportHeaders(rows) {
    if (!rows || rows.length === 0) return;
    let xlsxHeaders = [];
    for (var property in rows[0]) {
      if (rows[0].hasOwnProperty(property)) {
        xlsxHeaders.push({ title: property, dataIndex: property });
      }
    }
    this.setState({ xlsxHeaders: xlsxHeaders });
  }

  getFilteredData() {
    const { tableData, filterCompoundId } = this.state;
    return tableData.filter(
      (row) => !filterCompoundId || row.COUMPOUND_ID === filterCompoundId
    );
  }

  getEditFormData(row) {
    return post(
      this.state.singleItemUrl,
      { id: row.ID },
      this.props.updateIsLoading
    ).then((apiResponse) => {
      var data = this.state.data;

      data["Name"] = apiResponse.data.respData.data[0].NAME;
      data["Series"] = apiResponse.data.respData.data[0].SERIES;
      data["Price"] = apiResponse.data.respData.data[0].PRICE;
      data["InternetType"] = apiResponse.data.respData.data[0].INTERNET_TYPE;
      data["CompoundId"] = apiResponse.data.respData.data[0].COUMPOUND_ID;

      this.setState({
        data: data,
        editEntityId: apiResponse.data.respData.data[0].ID,
      });
    });
  }

  handleDelete(row) {
    confirmAlert({
      title: this.props.t("dialog.deleteTitle"),
      message: this.props.t("dialog.deleteConfirm"),
      buttons: [
        { label: this.props.t("btn.yes"),
          onClick: () => {
            post(
              this.state.deleteUrl,
              { id: row.ID },
              this.props.updateIsLoading
            ).then((apiResponse) => {
              apiResponse.data.respCode === 0 ? this.getData() : null;
            });
          },
        },
        { label: this.props.t("btn.cancel"),
          onClick: () => null,
        },
      ],
    });
  }

  doSubmit() {
    const submitData = Object.assign({}, this.state.data);

    if (this.state.inEditMode) {
      submitData["id"] = this.state.editEntityId;
    }

    post(
      this.state.inEditMode ? this.state.editUrl : this.state.addUrl,
      submitData,
      this.props.updateIsLoading
    ).then((apiResponse) => {
      if (apiResponse.data.respCode === 0) {
        this.props.updateIsLoading(false);
        this.closeModal();
      }
    });
  }

  render() {
    const { t } = this.props;
    return (
      <div className="bms-content-component fade-in">
        <div className="row">
          <div className="col">
            <h4>{t("pages.internetSubscribeTypes")}</h4>
          </div>
          <div className="col flex-container-left">
            {sysJwt.isAuthorized(["CB6A"]) && (
              <Button
                label={t("pages.addInternetSubscribeType")}
                icon={this.state.addButtonIcon}
                className="p-button-rounded p-button-secondary"
                disabled={this.props.isLoading}
                onClick={() => {
                  this.setState({ inEditMode: false });
                  this.showForm();
                }}
              />
            )}
          </div>
        </div>
        <hr />
        {/* Filter bar */}
        <div className="page-filter-bar">
          <span className="filter-label">{t("filter.compound")}:</span>
          <Dropdown
            value={this.state.filterCompoundId}
            options={this.state.compoundsDropdown}
            showClear
            filter
            onChange={(e) => this.setState({ filterCompoundId: e.value })}
            placeholder={t("filter.allCompounds")}
          />

          <Button
            label={t("filter.clear")}
            icon="fa fa-eraser"
            className="p-button-rounded p-button-secondary"
            disabled={this.props.isLoading}
            onClick={() => this.setState({ filterCompoundId: "" })}
          />

          {this.getFilteredData().length > 0 && (
            <ExportSheet
              header={this.state.xlsxHeaders}
              dataSource={this.getFilteredData()}
              fileName="InternetSubscribeTypes"
              isRequiredNameDate={false}
              xlsx={XLSX}
            >
              <Button
                className="p-button-rounded p-button-success"
                label={t("btn.exportExcel")}
                icon="fa fa-file-excel-o"
              />
            </ExportSheet>
          )}
        </div>
        <Dialog
          visible={this.state.inModalMode}
          style={{ width: this.state.modalWidth }}
          onHide={(e) => this.closeModal()}
          dismissableMask={true}
          closable={false}
          header={
            <h5 className="modal-header">
              {this.state.inEditMode ? t("dialog.editTitle") : t("dialog.addTitle")}
            </h5>
          }
          footer={
            <div>
              <Button
                label={this.state.inEditMode ? t("btn.edit") : t("btn.add")}
                icon={
                  this.state.inEditMode
                    ? this.state.modalSubmitButtonIconEdit
                    : this.state.modalSubmitButtonIconAdd
                }
                className="p-button-rounded p-button-secondary"
                disabled={this.props.isLoading}
                onClick={() => this.doSubmit()}
              />
              <Button
                label={t("btn.cancel")}
                icon="fa fa-close"
                className="p-button-rounded p-button-danger"
                onClick={() => this.closeModal()}
              />
            </div>
          }
        >
          <SysForm
            isLoading={this.props.isLoading}
            inEditMode={this.state.inEditMode}
            data={this.state.data}
            updateForm={this.updateForm}
            inputs={[
              {
                type: "text",
                id: "Name",
                label: t("col.name"),
                disabled: false,
              },
              {
                type: "text",
                id: "Series",
                label: t("col.series"),
                disabled: false,
              },
              {
                type: "text",
                id: "Price",
                label: t("col.price"),
                disabled: false,
              },
              {
                type: "dropdown",
                id: "InternetType",
                label: t("col.internetProvider"),
                options: this.state.internetTypesDropdown,
                disabled: false,
              },
              {
                type: "dropdown",
                id: "CompoundId",
                label: t("col.compound"),
                options: this.state.compoundsDropdown,
                disabled: false,
              },
            ]}
          />
        </Dialog>
        <SysTable
          columns={this.getColumns()}
          rows={this.getFilteredData()}
          pageSizes={[10, 15, 20, 25, 30]}
        />
      </div>
    );
  }
}

export default withTranslation()(InternetSubscribeTypes);
